import { FC } from 'react'
import { GeneralCommissionSettings } from './GeneralCommissionSettings'

export type componentName = string

export interface ITabList {
  tabLabel: string
  slug: string
  component: FC
}

export const tabList: ITabList[] = [
  {
    tabLabel: 'Commissions',
    slug: 'commissions',
    component: GeneralCommissionSettings,
  },
]
